import type { Options } from 'react-markdown'
import remarkCjkFriendly from 'remark-cjk-friendly'
import remarkCjkFriendlyGfmStrikethrough from 'remark-cjk-friendly-gfm-strikethrough'
import remarkGfm from 'remark-gfm'

// 模型回覆共用的 remark 外掛。CommonMark 下 ** 緊鄰「」（）等全形標點時強調不成立，
// cjk-friendly 修正判定；依套件說明須排在 remarkGfm 之後，刪除線那支才生效
export const REMARK_PLUGINS: NonNullable<Options['remarkPlugins']> = [
  remarkGfm,
  remarkCjkFriendly,
  remarkCjkFriendlyGfmStrikethrough,
]
